import * as React from 'react';

function SvgEyeFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
      <circle cx={16} cy={16} r={4} />
      <path d="M29.9 13.88C26.67 8.49 21.22 5 16 5S5.33 8.49 2.1 13.88L.84 16l1.26 2.12C5.33 23.51 10.79 27 16 27s10.67-3.49 13.9-8.88L31.17 16zM16 22a6 6 0 116-6 6 6 0 01-6 6z" />
    </svg>
  );
}

export default SvgEyeFilled;
